var SENTRY_RELEASE;SENTRY_RELEASE={name: "Kai Social", version: "0.8.4"};